import React, { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { useSearch } from "./SearchContext";
import "./css/searchbar.scss";

function SearchBar({ isOpen, onOpen, onClose }) {
  const [input, setInput] = useState("");
  const { searchData, setLastSearchResult } = useSearch();
  const navigate = useNavigate();
  const searchRef = useRef(null);

  useEffect(() => {
    function handleClickOutside(event) {
      if (searchRef.current && !searchRef.current.contains(event.target)) {
        onClose(); // Закрываем, если клик вне поиска
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [onClose]);

  const handleSearch = () => {
    const flattenedData = extractTitles(searchData);
    const results = flattenedData.filter((item) =>
      item.title.toLowerCase().includes(input.toLowerCase()) ||
      item.path.toLowerCase().includes(input.toLowerCase())
    );

    if (results.length > 0) {
      setLastSearchResult(results[0]);
      navigate("/results", {
        state: { path: results[0].path, title: results[0].title },
      });
    } else {
      setLastSearchResult(null);
      navigate("/results", { state: { path: null, title: null } });
    }
  };

  const extractTitles = (data, parentPath = "") => {
    let titles = [];
    data.forEach((item) => {
      if (item.title) {
        titles.push({ title: item.title, path: item.path || parentPath });
      }
      if (Array.isArray(item.sections)) {
        titles = titles.concat(extractTitles(item.sections, item.path || parentPath));
      }
      if (item.sections && typeof item.sections === "object" && !Array.isArray(item.sections)) {
        Object.entries(item.sections).forEach(([key, value]) => {
          if (value && typeof value === "object" && value.title) {
            titles.push({ title: value.title, path: `${parentPath}/${key}` });
            titles = titles.concat(extractTitles([value], `${parentPath}/${key}`));
          }
        });
      }
    });
    return titles;
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      handleSearch();
    }
  };

  const handleClear = () => {
    setInput(""); // Очищаем только текст, не закрывая поиск
  };

  return (
    <div className="search-bar-container" ref={searchRef}>
      <button onClick={isOpen ? onClose : onOpen} className="toggle-button">
        <img src="../img/svg/find.svg" alt="Search" width={20} />
      </button>

      {isOpen && (
        <div className="dropdown">
          <div className="input-wrapper">
            <input
              type="text"
              value={input}
              onChange={(e) => setInput(e.target.value)}
              onKeyDown={handleKeyDown}
              placeholder="Search..."
              className="search-input"
            />
            {input && (
              <button className="clear-button" onClick={handleClear}>
                ✖
              </button>
            )}
          </div>
          <button onClick={handleSearch} className="search-button">
            Search
          </button>
        </div>
      )}
    </div>
  );
}

export default SearchBar;

